module.exports = __webpack_public_path__ + "static/media/权益三@2x.d796a450.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_121/img/权益三@2x.png
// module id = 1138
// module chunks = 0